import { render } from "./LeaveListing.vue?vue&type=template&id=1c1128b7&scoped=true"
import script from "./LeaveListing.vue?vue&type=script&lang=js"
export * from "./LeaveListing.vue?vue&type=script&lang=js"

import "./LeaveListing.vue?vue&type=style&index=0&id=1c1128b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1128b7"]])

export default __exports__